import { render, staticRenderFns } from "./BatchModifyDelete.vue?vue&type=template&id=3a51c789&scoped=true"
import script from "./BatchModifyDelete.vue?vue&type=script&lang=js"
export * from "./BatchModifyDelete.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyDelete.vue?vue&type=style&index=0&id=3a51c789&prod&scoped=true&lang=css"
import style1 from "./BatchModifyDelete.vue?vue&type=style&index=1&id=3a51c789&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a51c789",
  null
  
)

export default component.exports